import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDollarTag = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		d: "M0,0h24v24h-24v-24Z",
		id: "a"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("use", { xlinkHref: "#a" }),
			/* @__PURE__ */ _jsx("use", { xlinkHref: "#a" }),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M11.89,12.11l0.55,-0.55"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M8.57,15.43l-0.55,0.55"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M8.013,14.071c-0.091,0.377 -0.009,0.783 0.286,1.078l0.276,0.276l0.329,0.329c0.428,0.428 1.122,0.428 1.55,0c0.355,-0.355 0.424,-0.907 0.165,-1.338l-0.775,-1.294c-0.258,-0.431 -0.19,-0.983 0.165,-1.338c0.428,-0.428 1.122,-0.428 1.55,0l0.329,0.329l0.276,0.276c0.294,0.294 0.376,0.699 0.287,1.075"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M15.8073,8.19266c0.144885,0.144885 0.144885,0.379789 0,0.524673c-0.144885,0.144885 -0.379789,0.144885 -0.524673,0c-0.144885,-0.144885 -0.144885,-0.379789 0,-0.524673c0.144885,-0.144885 0.379789,-0.144885 0.524673,0"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M13.512,4h4.385c1.162,0 2.103,0.941 2.103,2.102v4.385c0,0.558 -0.222,1.092 -0.616,1.487l-8.41,8.41c-0.821,0.821 -2.152,0.821 -2.973,0l-4.385,-4.385c-0.821,-0.821 -0.821,-2.152 0,-2.973l8.41,-8.41c0.394,-0.394 0.929,-0.616 1.486,-0.616Z"
			})
		]
	})]
});
export default SvgDollarTag;
